<template>
  <div class="modal">
    <button class="close" @click="toggleModal">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="512"
        height="512"
        viewBox="0 0 512 512"
      >
        <line
          x1="368"
          y1="368"
          x2="144"
          y2="144"
          stroke="#000"
          style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"
        />
        <line
          x1="368"
          y1="144"
          x2="144"
          y2="368"
          stroke="#000"
          style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"
        />
      </svg>
    </button>
    <slot />
  </div>
</template>

<script>
export default {
  name: "modal",
  props: {
    toggleModal: Function
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: var(--gutter);
  padding: var(--gutter);
  background: rgba(var(--gray-2), 0.8);
  backdrop-filter: saturate(180%) blur(1rem);
  color: rgb(var(--text-2));
  border-radius: var(--brs);
  z-index: 2;
}

.close {
  background: rgb(var(--gray-1));
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  border: none;
  font-size: 0;
  transition: var(--smooth-fast);
  position: absolute;
  right: calc(var(--gutter) / 2);
  top: calc(var(--gutter) / 2);
}

.close:hover {
  opacity: 0.6;
}

.close:hover svg {
  transform: rotate(360deg);
}

.close svg {
  transition: var(--smooth-slow);
  width: 1.2rem;
  height: 1.2rem;
}

.close svg line {
  stroke: rgb(var(--text-2));
}

@media (max-width: 768px) {
  .modal {
    width: calc(100% - var(--gutter));
  }
}
</style>
